import React from 'react';

import { flagStyles } from '../settings';

const SvgWS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5760px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgWS;
